import React, { useState, useEffect } from "react";

import { Link } from "react-router-dom";
import AuthService from "services/auth.service";
import {   
  Row,
  Col,
} from "reactstrap";

const TransactionList = () => {
  const [users, setUsers] = useState([]);
  const [currentUser, setCurrentUser] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(-1);
  const [searchEmail, setSearchEmail] = useState("");

  useEffect(() => {
    retrieveUsers();
  }, []);

  const onChangeSearchEmail = e => {
    const searchEmail = e.target.value;
    setSearchEmail(searchEmail);
  };

  const retrieveUsers = () => {
    AuthService.getAll()
      .then(response => {
        setUsers(response.data);
        //console.log(response.data);
      })
      .catch(e => {
        //console.log(e);
      });
  };

  const refreshList = () => {
    retrieveUsers();
    setCurrentUser(null);
    setCurrentIndex(-1);
  };

  const setActiveUser = (user, index) => {
    setCurrentUser(user);
    setCurrentIndex(index);
    
  };


  const removeAllTutorials = () => {
    AuthService.removeAll()
      .then(response => {
        //console.log(response.data);
        refreshList();
      })
      .catch(e => {
        //console.log(e);
      });
  };

  const findByTitle = () => {
    AuthService.findByTitle(searchEmail)
      .then(response => {
        setUsers(response.data);
        //(response.data);
      })
      .catch(e => {
        //console.log(e);
      });
  };

  
  
  return (
    <div className="content">
        <Row>
          <Col>
    <div className="list row">
      <div className="col-md-8">
        {/* <div className="input-group mb-3">
          <input
            type="text"
            className="form-control"
            placeholder="Search by email"
            value={searchEmail}
            onChange={onChangeSearchEmail}
          />
          <div className="input-group-append">
            <button
              className="btn btn-outline-secondary"
              type="button"
              onClick={findByTitle}
            >
              Search
            </button>
          </div>
        </div> */}
      </div>
      <div className="col-md-6 admin-visible">
        <h4  style={{
                        
                        color: "#333",
                      }}>User List</h4>

        <ul className="list-group">
          {users &&
            users.map((user, index) => (
              <li
                className={
                  "list-group-item " + (index === currentIndex ? "active" : "")
                }
                onClick={() => setActiveUser(user, index)}
                key={index}
              >
                {user.email}
              </li>
            ))}
        </ul>

        {/* <button
          className="m-3 btn btn-sm btn-danger"
          onClick={removeAllTutorials}
        >
          Remove All
        </button> */}
      </div>
      <div className="col-md-6 admin-visible">
        {currentUser ? (
          <div>
            <h4  style={{
                        
                        color: "#333",
                      }}>User</h4>
            <div>
              <label>
                <strong>Name:</strong>
              </label>{" "}
              {currentUser.firstName} {currentUser.lastName}
            </div>
            <div>
              <label>
                <strong>Available Balance:</strong>
              </label>{" $"} 
              {currentUser.availableBalance}
            </div>
            <div>
              <label>
                <strong>Pending Payment:</strong>
              </label>{" $"} 
              {currentUser.pendingPayment}
            </div>
              
            {/* <div>
              <label>
                <strong>Status:</strong>
              </label>{" "}
              {currentUser.published ? "Published" : "Pending"}
            </div> */}

            <Link
              to={"/admin/transaction/" + currentUser.id}
              className="badge badge-warning"
            >
              Add Transaction to this user
            </Link>
            <Link
              to={"/admin/transaction/" + currentUser.id + "/view"}
              className="badge badge-info"
            >
              View Transactions
            </Link>
           
          </div>
        ) : (
          <div>
            <br />
            <p>Please click on a User to see the User transaction..</p>
          </div>
        )}
      </div>
    </div>
    </Col>
    </Row>
    </div>
  );
};

export default TransactionList;